import axios from 'axios'
import config from '../config'
import { getDoctorToken } from "../utils"

const getDtrfReportListApi = async (params) => {
    let cancelToken
    //Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    const response = await axios({
        url: `${config.api.base_url}test-master/test-reports`,
        method: "get",
        params: params,
        cancelToken: cancelToken.token,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`
        }
    })

    return response

}

export default getDtrfReportListApi